import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { getGHGStandards } from '../../../api/ghg';

interface RegistrySelectProps {
  value?: string[];
  onChange?: (value: string[]) => void;
}

/**
 * Multi-select of registries (GHG standards), for use as the child of a Form.Item.
 * Its value is the list of registry ids the backend expects as `registry_ids`.
 */
const RegistrySelect: React.FC<RegistrySelectProps> = ({ value, onChange }) => {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchRegistries() {
      setLoading(true);
      try {
        const standards = await getGHGStandards();
        setOptions(
          (standards.response as any[])
            .map((s) => ({ value: s.id, label: s.code }))
            .sort((a, b) => a.label.localeCompare(b.label)),
        );
      } catch (error) {
        console.error('Error fetching registries:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchRegistries();
  }, []);

  return (
    <Select
      mode="multiple"
      allowClear
      showSearch
      optionFilterProp="label"
      placeholder="Select registries"
      loading={loading}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default RegistrySelect;
